import { defineComponent } from 'vue';
import configs from '../../configs';
export default defineComponent({
    props: {
        src: {
            type: String,
            default: '',
            require: true
        },
        srcSp: {
            type: String,
            default: '',
            require: false
        },
        alt: {
            type: String,
            default: '',
            require: false
        },
        loading: {
            type: String,
            default: 'lazy',
            validator: function (value) { return ['eager', 'lazy'].includes(value); }
        },
        media: {
            type: String,
            default: '(min-width: 1024px)',
            require: false
        }
    },
    computed: {
        cdnImage: function () {
            return this.$config.cdnImage;
        }
    },
    methods: {
        onRenderCDN: function (url) {
            if (url.includes(configs.cdnImage.ctf) && this.cdnImage !== configs.cdnImage.ctf) {
                return "" + url.replaceAll(configs.cdnImage.ctf, this.cdnImage);
            }
            return url;
        }
    }
});
